// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__14qMs","ScrollX":"Scroll_ScrollX__3_LzU","ScrollY":"Scroll_ScrollY__3AcvN"};